import React from "react";
import {Notification} from "rsuite";

// rsuite is handing us a ref here, figure out how to deal with this issue later
// TODO
//  Warning: Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?
const ErrorNotification = (props) => {
    const { message } = props;
    return (
        <Notification {...props} type="error" header={"Error"} duration={3000}>
            {message}
        </Notification>
    );
};

export default ErrorNotification;